import React, { FC } from 'react';
import styled from 'styled-components';

import { blue } from '@vimeo/iris/color';
import { IrisTheme } from '@vimeo/iris/themes';
import { Link } from '@vimeo/iris/typography';

import { AlbumDescription } from './CustomGridHeaderStyled';

interface Props {
  children: string;
  theme?: IrisTheme;
}

/**
 * This component will scan the child text for links and wrap them in a `LinkText` component
 * so links can be interactive within an `AlbumDescription`.
 */
export const AlbumDescriptionWithLinks: FC<Props> = ({ children, theme }: Props) => {
  const tokens = children.split(/\s/);

  const contents = tokens.map((token, i) => {
    const hasSpace = i !== tokens.length - 1;
    const maybeSpace = hasSpace ? ' ' : '';
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    if (token.match(urlRegex)) {
      return (
        <>
          <StyledLink variant="minimal" target="_blank" key={i} href={token}>
            {token}
          </StyledLink>
          {maybeSpace}
        </>
      );
    } else {
      return token + maybeSpace;
    }
  });

  return <AlbumDescription theme={theme}>{contents}</AlbumDescription>;
};

export const StyledLink = styled(Link)`
  color: ${blue(500)} !important;
  &:visited {
    color: ${blue(500)} !important;
  }
`;
